// extracted by mini-css-extract-plugin
export var button = "_5s-4";
export var hasDarkBackground = "_5s-7";
export var hasLightBackground = "_5s-6";
export var iconWrapper = "_5s-0";
export var large = "_5s-2";
export var medium = "_5s-1";
export var small = "_5s-5";
export var xsmall = "_5s-3";